import { render, staticRenderFns } from "./IconMoreVertical.vue?vue&type=template&id=50074d4c&"
import script from "./IconMoreVertical.vue?vue&type=script&lang=js&"
export * from "./IconMoreVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports